(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/match-view.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/match-view.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.MatchView = Backbone.Model.extend({
    initialize: function() {
      this.listenTo(
        svs.tipset.collections.matchlist,
        'currentMatchSet',
        this.update
      );
      this.update();
    },

    update: function() {
      if (
        !svs.tipset.collections.matchlist ||
        !svs.tipset.collections.matchlist.getCurrentMatch()
      ) {
        return;
      }

      var matchNr = svs.tipset.collections.matchlist
          .getCurrentMatch()
          .get('eventNumber'),
        drawUrlAddOn = svs.tipset.collections.draws
          .getCurrentDraw()
          .get('urlAddOn'),
        eventDescription = svs.tipset.collections.matchlist
          .getCurrentMatch()
          .get('eventDescription')
          .replace(/ - /g, '-'),
        currentCompetitionUrl = svs.tipset.models.competition
          ? svs.tipset.models.competition.getCompetitionUrl()
          : '',
        url =
          currentCompetitionUrl +
          drawUrlAddOn +
          '/' +
          matchNr +
          '-' +
          svs.utils.url.encode(eventDescription);
      this.set({
        currentRound: svs.tipset.collections.draws.getCurrentDraw().toJSON(),
        matchNr: matchNr,
        match:
          svs.tipset.collections.matchlist.getCurrentMatch() &&
          svs.tipset.collections.matchlist.getCurrentMatch().get('match')
            ? svs.tipset.collections.matchlist.getCurrentMatch().get('match')
            : '',
        eventDescription: eventDescription,
        url: url
      });
    },
    fixURL: function() {
      return this.get('url') + window.location.search;
    }
  });
})(Backbone, _, svs);

 })(window);